/**
 * The i18n layer (U8, W2).
 *
 * The three namespaces below are eager: the kit and the permission catalogue are
 * needed before any module renders, and `common` is the default namespace.
 * Module namespaces register themselves through `app.config.tsx`.
 */
import { commonCatalogs } from './common';
import { permissionCatalogs } from './permissions';
import { registerCatalog } from './register-catalog/register-catalog';
import { uiKitCatalogs } from './ui-kit';

registerCatalog('common', commonCatalogs);
registerCatalog('uiKit', uiKitCatalogs);
registerCatalog('permissions', permissionCatalogs);

export * from './catalog-parity/catalog-parity';
export * from './i18n.config';
export * from './permissions/permissions.util';
export * from './register-catalog/register-catalog';
